import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, ShieldCheck } from "lucide-react";

export default function ConsentLog() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/consent-log").then((r) => setData(r.data)).catch(() => setData({ records: [], by_version: {}, total: 0, current_version: "" }));
  }, []);
  if (!data) return <div className="py-10 grid place-items-center"><Loader2 className="h-5 w-5 animate-spin text-sam-crimson" /></div>;
  const fmt = (s) => (s ? new Date(s).toLocaleString() : "—");
  return (
    <div className="space-y-4" data-testid="consent-log">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 text-sam-navy font-display text-lg font-bold"><ShieldCheck className="h-5 w-5 text-sam-green" />Terms consent log</div>
        <span className="text-xs text-sam-slate">Current version: <b>{data.current_version}</b> · {data.total} record{data.total === 1 ? "" : "s"}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {Object.entries(data.by_version || {}).map(([v, n]) => (
          <span key={v} className="rounded-full bg-sam-cream border border-border px-3 py-1 text-xs text-sam-navy" data-testid={`consent-version-${v}`}>{v}: <b>{n}</b></span>
        ))}
      </div>
      <div className="overflow-x-auto rounded-xl border border-border">
        <table className="w-full text-sm">
          <thead className="bg-sam-cream/60 text-sam-slate text-xs uppercase tracking-wide">
            <tr>
              <th className="text-left p-3">Who</th>
              <th className="text-left p-3">Source</th>
              <th className="text-left p-3">Version</th>
              <th className="text-left p-3">Accepted at</th>
            </tr>
          </thead>
          <tbody>
            {data.records.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-sam-slate">No consent records yet.</td></tr>}
            {data.records.map((r, i) => (
              <tr key={i} className="border-t border-border" data-testid={`consent-row-${i}`}>
                <td className="p-3"><div className="font-semibold text-sam-navy">{r.who}</div>{r.email && <div className="text-xs text-sam-slate">{r.email}</div>}</td>
                <td className="p-3 text-sam-slate">{r.source}</td>
                <td className="p-3"><span className="rounded bg-sam-navy/10 text-sam-navy text-xs font-semibold px-2 py-0.5">{r.version || "—"}</span></td>
                <td className="p-3 text-sam-slate">{fmt(r.at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
